import {JsonProperty} from '../shared/decorators/json-property';

export class MamApprovalModel {
  @JsonProperty('mt4_request_mam_master_account_id')
  id: number;
  @JsonProperty('user_id')
  userId: number;
  @JsonProperty('account_type')
  accountType: number;
  @JsonProperty('allocation_method')
  allocationMethod: number;
  @JsonProperty('group_follower')
  group: string;
  currency: string;
  email: string;
  @JsonProperty('first_name')
  firstName: string;
  @JsonProperty('middle_name')
  middleName: string;
  @JsonProperty('last_name')
  lastName: string;
  @JsonProperty('create_time')
  createTime: number;
  @JsonProperty('groups_configs')
  groupConfigs: number;
  constructor() {
    this.id = undefined;
    this.userId = undefined;
    this.accountType = undefined;
    this.allocationMethod = undefined;
    this.currency = undefined;
    this.lastName = undefined;
    this.middleName = undefined;
    this.firstName = undefined;
    this.email = undefined;
    this.group = undefined;
    this.createTime = undefined;
    this.groupConfigs = undefined;
  }
  getUsername(): string {
    return this.firstName + ' ' + this.lastName;
  }
  getAccountType(): any {
    switch (this.accountType) {
      case 0: {
        return 'Standard';
      }
      case 1: {
        return 'Zero Spread';
      }
    }
  }
}
export class GroupMamMasterModel {
  @JsonProperty('group_config_id')
  id: number;
  @JsonProperty('user_id')
  userId: number;
  @JsonProperty('is_mam')
  isMam: number;
  @JsonProperty('create_time')
  createTime: number;
  @JsonProperty('allocation_method')
  allocationMethod: string;
  type: number;
  name: string;
  currency: string;
  data: any;
  constructor() {
    this.id = undefined;
    this.userId = undefined;
    this.isMam = undefined;
    this.createTime = undefined;
    this.type = undefined;
    this.name = undefined;
    this.currency = undefined;
    this.data = undefined;
    this.allocationMethod = undefined;
  }
}
export class MamFollowerModel {
  @JsonProperty('user_id')
  id: number;
  login: number;
  @JsonProperty('group_follower')
  currentGroup: string;
  @JsonProperty('first_name')
  firstName: string;
  @JsonProperty('last_name')
  lastName: string;
  @JsonProperty('middle_name')
  middleName: string;
  @JsonProperty('group_followers')
  groups: string;
  @JsonProperty('master_id')
  masterId: number;
  @JsonProperty('master_email')
  masterEmail: number;
  email: string;
  @JsonProperty('total_order')
  totalOrder: number;
  @JsonProperty('currency')
  currency: string;
  @JsonProperty('total_balance')
  totalBalance: number;
  @JsonProperty('total_profit')
  totalPNL: number;
  @JsonProperty('realized_pnl')
  realizedPnl: number;
  withdraw: number;
  deposit: number;
  @JsonProperty('net_asset')
  netAsset: number;
  @JsonProperty('total_profit_by_bonus')
  totalPBB: number;
  @JsonProperty('total_bonus_used')
  bonusContribution: number;
  bonus:number;
  @JsonProperty('total_volume')
  totalVolume: number;
  @JsonProperty('is_pam')
  isPam: number;
  constructor() {
    this.id = undefined;
    this.login = undefined;
    this.currentGroup = undefined;
    this.firstName = undefined;
    this.lastName = undefined;
    this.middleName = undefined;
    this.groups = undefined;
    this.email = undefined;
    this.masterId = undefined;
    this.totalVolume= undefined;
    this.totalOrder = undefined;
    this.currency = undefined;
    this.totalBalance = undefined;
    this.totalPNL = undefined;
    this.realizedPnl = undefined;
    this.withdraw = undefined;
    this.deposit = undefined;
    this.netAsset = undefined;
    this.totalPBB = undefined;
    this.bonusContribution = undefined;
    this.bonus= undefined;
    this.masterEmail = undefined;
    this.isPam = undefined;
  }

  getUserName(): string {
    return this.firstName + ' ' + this.lastName;
  }

  getPercentBalanceRatio(): string {
    if (this.totalBalance && this.totalBalance !==  0 && this.totalPNL && this.totalPNL !== 0) {
      return ((this.totalPNL / this.totalBalance) * 100).toFixed(2) + ' %';
    }
    return '0 %';
  }
}

export class MamFollowerDetailModel {
  @JsonProperty('user_id')
  id: number;
  login: number;
  @JsonProperty('first_name')
  firstName: string;
  @JsonProperty('last_name')
  lastName: string;
  @JsonProperty('middle_name')
  middleName: string;
  email: string;
  @JsonProperty('currency')
  currency: string;
  @JsonProperty('total_order')
  totalOrder: number;
  @JsonProperty('total_balance')
  totalBalance: number;
  @JsonProperty('total_profit')
  totalPNL: number;
  @JsonProperty('realized_pnl')
  realizedPnl: number;
  withdraw: number;
  deposit: number;
  @JsonProperty('net_asset')
  netAsset: number;
  @JsonProperty('total_profit_by_bonus')
  totalPBB: number;
  @JsonProperty('total_bonus_used')
  bonusContribution: number;
  bonus:number;
  @JsonProperty('total_volume')
  totalVolume: number;
  constructor() {
    this.id = undefined;
    this.login = undefined;
    this.firstName = undefined;
    this.lastName = undefined;
    this.middleName = undefined;
    this.email = undefined;
    this.currency = undefined;
    this.totalVolume= undefined;
    this.totalOrder = undefined;
    this.totalBalance = undefined;
    this.totalPNL = undefined;
    this.realizedPnl = undefined;
    this.withdraw = undefined;
    this.deposit = undefined;
    this.netAsset = undefined;
    this.totalPBB = undefined;
    this.bonusContribution = undefined;
    this.bonus= undefined;
  }

  getUserName(): string {
    return this.firstName + ' ' + this.lastName;
  }

  getPercentBalanceRatio(): string {
    if (this.totalBalance !==  0 && this.totalPNL !== 0) {
      return ((this.totalPNL / this.totalBalance) * 100).toFixed(2) + ' %';
    }
    return '0 %';
  }
}

